export default "__VITE_ASSET__B$ozFfsi__"